import Vue from 'vue'

export default {
  namespaced: true,

  state: {
    sendingData: false,
    serverErrors: {},
  },

  mutations: {
    setSendingData(state, status) {
      state.sendingData = status
    },

    setServerErrors(state, errors) {
      state.serverErrors = errors
    },

    removeServerErrors(state, field) {
      Vue.set(state.serverErrors, field, '')
    },

    clearServerErrors(state) {
      state.serverErrors = {}
    },
  },
}
